<template>
    <div :class="'img-' + size" class="custom-icon">
        <svg viewBox="0 0 130 130" xmlns="http://www.w3.org/2000/svg"><g stroke="none" stroke-width="4" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><rect class="path" stroke="#0C2340" x="25" y="2" width="80" height="126" rx="10"/><path d="M47 118.5h36M60 65v24H36V65h24zM50 75h-4v4h4v-4zm10-44v24H36V31h24zM50 41h-4v4h4v-4zm20 48V65m24 0v16m-18 2h6m0-6v-6m6 10v-7m6-9h-6M76 89h-6m6-6v-4m6-14h-6m6 24h4m8-2v2h-2v-2h2zm0-56v24H70V31h24zM84 41h-4v4h4v-4z" class="highlight" stroke="#00BBDC"/></g></svg>
    </div>
</template>

<script>
    export default {
        props: {
            size: {
                type: String,
                default: '4x'
            }
        }
    }
</script>